<template>
  <div class="site-header flex-row-between shadow">
    <img class="index-img" :src="indexImgSrc">
  </div>
</template>

<script>
export default {
  name: "site-header",
  components : { },
  data(){
    return {
      indexImgSrc: require("@/assets/img/cmdinfo-header.jpg")

    }
  }
}
</script>

<style lang="less" scoped>
// @import "~@/assets/define.less";
.site-header{
  
}
</style>
